import React from "react";
import Background from "components/Background/Background";
import Container from "components/Container/Container";
import SocialRegisterCodeView from "views/Torus/SocialRegisterCode/SocialRegisterCodeView";
import Back from "components/BackButton/Back";

interface IProps {
  socialAdress: string;
}

const SocialRegisterCode: React.FC<IProps> = ({ socialAdress }) => {
  return (
    <Background>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container>
          <Back link="/" />

          <SocialRegisterCodeView socialAdress={socialAdress} />
        </Container>
      </div>
    </Background>
  );
};

export default SocialRegisterCode;
